import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';
import { reducer as toastrReducer } from 'react-redux-toastr';

import Com_ProjectReducer_Dwk from './Com_ProjectReducer_Dwk';
import Resi_ProjectReducer_Dwk from './Resi_ProjectReducer_Dwk';
import Com_PropertyReducer_Dwk from './Com_PropertyReducer_Dwk';
import Resi_PropertyReducer_Dwk from './Resi_PropertyReducer_Dwk';

import Com_PropertyReducer_Ggn from './Com_PropertyReducer_Ggn';
import Resi_PropertyReducer_Ggn from './Resi_PropertyReducer_Ggn';

import ReviewReducer from './ReviewReducer';
import AwardReducer from './AwardReducer';
import PropOverviewReducer from './PropOverviewReducer';
// import ContactUsReducer from './ContactUsReducer';

import AuthReducer from './AuthReducer';
import ModalsReducer from './ModalReducer';
import CommonReducer from './CommonReducer';
// import AppParameterReducer from './AppParameterReducer';
import NameReducer_Dwk from './NameReducer_Dwk';
import NameReducer_Ggn from './NameReducer_Ggn';


export default combineReducers({
  // appParameters:AppParameterReducer,
  commons: CommonReducer,
  modals: ModalsReducer,
  auth: AuthReducer,
  reviews: ReviewReducer,
  awards: AwardReducer,
  propOverviews: PropOverviewReducer,
  // contactUss: ContactUsReducer,
  toastr: toastrReducer,
  form: formReducer,
  dwk_com_project: Com_ProjectReducer_Dwk,
  dwk_resi_project: Resi_ProjectReducer_Dwk,
  dwk_com_property: Com_PropertyReducer_Dwk,
  dwk_resi_property: Resi_PropertyReducer_Dwk,
  dwk_name:NameReducer_Dwk,
  
  ggn_com_property: Com_PropertyReducer_Ggn,
  ggn_resi_property: Resi_PropertyReducer_Ggn,
  ggn_name:NameReducer_Ggn,
  
});

// export default combineReducers({
//   appParameters:AppParameterReducer,
//   commons: CommonReducer,
//   modals: ModalsReducer,
//   auth: AuthReducer,
//   form: formReducer,
//   projectcoms: ProjectComReducer,
//   projectresis: ProjectResiReducer,
//   propcoms: PropComReducer,
//   propresis: PropResiReducer,
//   reviews: ReviewReducer,
//   awards: AwardReducer,
//   propOverviews: PropOverviewReducer,
//   // contactUss: ContactUsReducer,
//   toastr: toastrReducer,
// });